import React from "react";
import { Toast, ToastClose, ToastDescription, ToastTitle } from "@/components/ui/toast";
import type { ToasterToast } from "@/components/ui/toasts/types";

interface ToasterRowProps {
  toast: ToasterToast;
  closeToast: (id: string) => void;
}

export const ToasterRow: React.FC<ToasterRowProps> = ({ toast, closeToast }) => (
  <Toast open={toast.open} onOpenChange={() => closeToast(toast.id)}>
    <div className="grid gap-1">
      {toast.title && <ToastTitle>{toast.title}</ToastTitle>}
      {toast.description && <ToastDescription>{toast.description}</ToastDescription>}
    </div>
    {toast.action}
    <ToastClose />
  </Toast>
);
